import React, { createElement, useCallback } from 'react';
import { setFontName } from 'roosterjs-editor-api';
import styled from 'styled-components';
import { IBaseComponentProps } from '../../../types';
import { selectThemeSemantics } from '../../../../styling';
import { Dropdown, IDropdownItemRenderProps, IDropdownOption } from '../../../dropdown';
import { useFormatState, useToolbarActionContext } from '../context';
import { CommandButton } from './command-button';
import { IEditorToolbarActionBaseProps } from './types';

const OPTIONS: IDropdownOption[] = [
    {
        key: 'arial',
        text: 'Arial'
    },
    {
        key: 'calibri',
        text: 'Calibri'
    },
    {
        key: '"Courier New"',
        text: 'Courier New'
    },
    {
        key: 'georgia',
        text: 'Georgia'
    },
    {
        key: 'impact',
        text: 'Impact'
    },
    {
        key: '"Lucida Console"',
        text: 'Lucida Console'
    },
    {
        key: 'roboto',
        text: 'Roboto'
    },
    {
        key: 'tahoma',
        text: 'Tahoma'
    },
    {
        key: '"Times New Roman"',
        text: 'Times New Roman'
    },
    {
        key: '"Trebuchet MS"',
        text: 'Trebuchet MS'
    },
    {
        key: 'verdana',
        text: 'Verdana'
    },
    {
        key: 'webdings',
        text: 'Webdings'
    }
];

function ItemBase(props: IDropdownItemRenderProps & IBaseComponentProps) {
    const { className, renderDefault } = props;
    return (
        <div className={className}>
            {renderDefault()}
        </div>
    );
}

const Item = styled(ItemBase)`
    height: 100%;
    font-family: ${({ data }) => data.key};
`;

const StyledDropdown = styled(Dropdown)`
    height: 25px;
    width: 150px;

    .ap-dropdown-value {
        font-size: ${selectThemeSemantics(({ baseFont: { fontSize } }) => fontSize)};
    }
`;

const onRenderItem = (props: IDropdownItemRenderProps) => createElement(Item, props);

function FontFamilyActionBase(props: IEditorToolbarActionBaseProps) {
    const { editor } = useToolbarActionContext();
    const { fontFamily } = editor.getDefaultFormat();
    const { fontName = fontFamily } = useFormatState();

    const _onChange = useCallback(([selectedKey]: React.Key[]) => {
        setFontName(editor, selectedKey as string);
        editor.triggerContentChangedEvent();
    }, [editor]);

    const onRenderCommand = useCallback(() => (
        <StyledDropdown items={OPTIONS} disableRefocusTarget selectedKeys={fontName} showSearchBox={false} onRenderItem={onRenderItem} onValueChange={_onChange} />
    ), [_onChange, fontName]);

    return (
        <CommandButton {...props} tooltip="Font Family" iconName="ap-font.rte" onRender={onRenderCommand} />
    );
}

export const FontFamilyAction = styled(FontFamilyActionBase)`
    padding: 0 8px;
`;
